import { render } from "./baseline-scan.vue?vue&type=template&id=2beaecf6&scoped=true&ts=true"
import script from "./baseline-scan.vue?vue&type=script&lang=ts"
export * from "./baseline-scan.vue?vue&type=script&lang=ts"

import "./baseline-scan.vue?vue&type=style&index=0&id=2beaecf6&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2beaecf6"]])

export default __exports__